import React, { useState, useEffect, useMemo } from 'react';
import { CrudMasterDetailView, GridView, CrudContext, CompositeView, notification, SimpleView } from '@digital/ui';
import { getAllFechamento } from '@app/api/fechamento';
import FechamentoModuloExecutado from './fechamentoModuloExecutado';
import FechamentoControleRfa from './fechamentoControleRfa';
import FechamentoPluriAnual from './fechamentoPluriAnual';
import FechamentoCicloOrcamentario from './fechamentoCicloOrcamentario';
import FechamentoCurvaEconomica from './fechamentoCurvaEconomica';
import FechamentoExecutiveSummary from './fechamentoExecutiveSummary';
import { Row, Col } from 'antd';
import { hasPermission } from '@app/helpers/permissions';
import FechamentoProjetoOverView from './fechamentoProjetoOverView';
import FechamentoAreaExecutiveSummary from './fechamentoAreaExecutiveSummary';

const Fechamento = () => {
  const [allFechamento, setFechamento] = useState(() => getAllFechamento);

  useEffect(() => { }, []);

  return (
    <CrudMasterDetailView
      getAllItems={allFechamento}
      filterPredicate={(item, value) => item.ano.toString().startsWith(value)}
      titleExtractor={item => item.ano.toString() + '/' + item.mes.toString()}
      detailTitleExtractor={item => item.ano.toString() + ' - ' + item.mes.toString()}
      descriptionExtractor={item => `Versão: ${item.versao}`}>
      <CrudContext.Consumer>
        {({ selectedItem }) => (
          <CompositeView>
            {hasPermission(['FECHAMENTO_EXECUTIVE_SUMMARY_VISUALIZAR']) && selectedItem ? (
              <GridView icon="files-new_by_copy" id={`executiveSummary`} noform title="EXECUTIVE SUMMARY">
                <FechamentoExecutiveSummary fechamentoId={selectedItem.id} />
              </GridView>
            ) : (
              () => { }
            )}

            {hasPermission(['FECHAMENTO_CURVA_ECONOMICA_VISUALIZAR']) && selectedItem ? (
              <GridView icon="files-new_by_copy" id="cruvaEconomica" noform title="CURVA ECONÔMICA">
                <FechamentoCurvaEconomica fechamentoId={selectedItem.id} />
              </GridView>
            ) : (
              () => { }
            )}

            {hasPermission(['FECHAMENTO_AREA_EXECUTIVE_SUMMARY_VISUALIZAR']) && selectedItem ? (
              <GridView icon="files-new_by_copy" id="areaExecutiveSummay" noform title="ÁREA - EXECUTIVE SUMMARY">
                <FechamentoAreaExecutiveSummary
                  fechamentoId={selectedItem.id}
                />
              </GridView>
            ) : (
              () => { }
            )}

            {true && hasPermission(['FECHAMENTO_REPORT_PERFORMACE_PROJECT_VISUALIZAR']) && selectedItem ? (
              <GridView icon="files-new_by_copy" id="projetoOverView" noform title="REPORT PERFORMACE PROJECT">
                <FechamentoProjetoOverView fechamentoId={selectedItem.id} />
              </GridView>
            ) : (
              () => { }
            )}
            {true && selectedItem ? (
              <GridView icon="files-new_by_copy" id="cicloOrcamentario" noform title="CICLO ORÇAMENTARIO">
                <FechamentoCicloOrcamentario fechamentoId={selectedItem.id} />
              </GridView>
            ) : (
              () => { }
            )}

            {true && selectedItem ? (
              <GridView icon="files-new_by_copy" id="pluriAnual" noform title="PLURIANUAL">
                <FechamentoPluriAnual fechamentoId={selectedItem.id} />
              </GridView>
            ) : (
              () => { }
            )}

            {true && selectedItem ? (
              <GridView icon="files-new_by_copy" id="controleRfa" noform title="CONTROLE RFA">
                <FechamentoControleRfa fechamentoId={selectedItem.id} />
              </GridView>
            ) : (
              () => { }
            )}

            {true && selectedItem ? (
              <GridView icon="files-new_by_copy" id="moduloExecutado" noform title="MODULO EXECUTADO">
                <FechamentoModuloExecutado fechamentoId={selectedItem.id} />
              </GridView>
            ) : (
              () => { }
            )}
          </CompositeView>
        )}
      </CrudContext.Consumer>
    </CrudMasterDetailView>
  );
};

export default Fechamento;
